import { render, staticRenderFns } from "./PopUpFormError.vue?vue&type=template&id=2f185796&scoped=true&"
import script from "./PopUpFormError.vue?vue&type=script&lang=js&"
export * from "./PopUpFormError.vue?vue&type=script&lang=js&"
import style0 from "./PopUpFormError.vue?vue&type=style&index=0&id=2f185796&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f185796",
  null
  
)

export default component.exports